import { Check, Input } from "@frui.ts/bootstrap";
import { observer } from "mobx-react-lite";
import React from "react";
import FormGroup from "controls/formGroup";
import FormLabel from "controls/formLabel";
import { Row, Form, Col } from "react-bootstrap";
import type CountryCreateViewModel from "viewModels/timeCharges/distributorEnums/countries/countryCreateViewModel";
import type CountryDetailViewModel from "viewModels/timeCharges/distributorEnums/countries/countryDetailViewModel";

export interface CountryFormProps {
  vm: CountryCreateViewModel | CountryDetailViewModel;
  children?: React.ReactNode;
}

const CountryForm = observer((props: CountryFormProps) => {
  const { vm, children } = props;
  const disabled = !vm.isEditable;

  return (
    <>
      <Row>
        <Col md={6}>
          <Form.Row>
            <FormGroup as={Col} md={12} target={vm.item} property="name">
              <FormLabel>{vm.translateAttribute("name")}</FormLabel>
              <Input disabled={disabled} />
            </FormGroup>
            <FormGroup as={Col} md={12} target={vm.item} property="enName">
              <FormLabel>{vm.translate("enName")}</FormLabel>
              <Input disabled={disabled} />
            </FormGroup>
            <FormGroup as={Col} md={12} target={vm.item} property="deName">
              <FormLabel>{vm.translate("deName")}</FormLabel>
              <Input disabled={disabled} />
            </FormGroup>
            <FormGroup as={Col} md={12} target={vm.item} property="ruName">
              <FormLabel>{vm.translate("ruName")}</FormLabel>
              <Input disabled={disabled} />
            </FormGroup>
            <FormGroup as={Col} md={12} target={vm.item} property="plName">
              <FormLabel>{vm.translate("plName")}</FormLabel>
              <Input disabled={disabled} />
            </FormGroup>
            <FormGroup as={Col} md={12} target={vm.item} property="huName">
              <FormLabel>{vm.translate("huName")}</FormLabel>
              <Input disabled={disabled} />
            </FormGroup>
          </Form.Row>
        </Col>
        <Col md={6}>
          <Form.Row>
            <FormGroup as={Col} md={12} target={vm.item} property="code">
              <FormLabel>{vm.translateAttribute("code")}</FormLabel>
              <Input disabled={disabled} />
            </FormGroup>
            <FormGroup as={Col} md={12} target={vm.item} property="isSepaMember">
              <FormLabel>{vm.translateAttribute("isSepaMember")}</FormLabel>
              <Check custom type="checkbox" disabled={disabled} label={vm.translate("isSepaMember")} />
            </FormGroup>
          </Form.Row>
        </Col>
      </Row>
      {children}
    </>
  );
});

export default CountryForm;
